export enum UserTypes {
    Employee = 1,
    Landman,
    ClientLandman,
}

export default class UserType {
    id: number;
    name: string;
}



// WEBPACK FOOTER //
// ./src/models/UserType.ts